import React, { useState, useEffect, useRef } from "react";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import ReactApexChart from "react-apexcharts";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import dayjs from "dayjs";

import { Table, Input } from "antd";
import Select from 'react-select';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { ApexOptions } from "apexcharts";

import { fetchPannelData } from "../../auth/services/apiCalling"; // Import API function
// import { Trader,TraderPending,LicenseCount,EntityTypeCount,DistrictCount,DepartmentCount,TraderStatusCount } from "./interface";
import DataTable from "../../../core/common/dataTable/index";

import { fetchTraderPannelData } from "../../auth/services/apiCalling";
import { fetchPanelTablesData } from "../../auth/services/apiCalling";
import { fetchApplicantDataPanel } from "../../auth/services/apiCalling";
import { getAllAPMC } from "../../auth/services/apiCalling";
import { fetchUserAssignedDistrictWithAPMC } from "../../auth/services/apiCalling";


const PannelEnginnerDashboard = () => {

  type PanelCount = {
    pending: number;
    approved: number;
    raiseQuery: number;
    resubmission: number;
    total: number;
    amountCollected: number;
  };
  const defaultPanelCount: PanelCount = {
    pending: 0,
    approved: 0,
    raiseQuery: 0,
    resubmission: 0,
    total: 0,
    amountCollected: 0,
  };

  const [departmentGroup, setdepartmentGroup] = useState([]);
  const [districtGroup, setdistrictGroup] = useState([]);
  const [searchText, setSearchText] = useState<string>("");

  const [apmcSelect, setApmcSelect] = useState(null);
  const [districSelect, setDistricSelect] = useState([{ value: '', label: '' }]);
  const [distrincData, setDistrincData] = useState<any>([])
  const [apmcData, setApmcData] = useState<any>([])
  const [apmcOptions, setApmcOptions] = useState([]);
  const [statusSelect, setStatusSelect] = useState({ value: "all", label: "All Application" });

  const [panelCountOne, setPanelCountOne] = useState<PanelCount>(defaultPanelCount)
  const [panelCountThree, setPanelCountThree] = useState<PanelCount>(defaultPanelCount)
  const [licenseSumm, setLicenseSumm] = useState({});
  const [appData, setAppData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loader1, setLoader1] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [loader3, setLoader3] = useState(false);

  const routes = all_routes;
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");

  const language = useSelector((state: any) => state.auth.language);
  const token = useSelector((state: any) => state.auth.token)
  const userDetail = useSelector((state: any) => state.auth.userDetails)
  const navigate = useNavigate();  // Initialize navigate function

  const userRoleDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userRoleDetail?.Role?.Role_Identifier;

  // const handleNavigate = () => {
  //   navigate('/application-pending');
  // };


  // const handleNavigate = () => {
  //   const restrictedRoles = ["SEC", "TR", "PER"];
  //   const allowedRoles = ["JC", "COM", "Dr", "SC", "DT", "HJC", "SA", "HJC", "DY", "HOS", "HJR"];

  //   if (allowedRoles.includes(userDetail?.Role?.Role_Identifier)) {
  //     navigate('/panel-application');  // ✅ Navigate for allowed roles
  //   }
  // };
  // const handleNavigate_lic = () => {
  //   const restrictedRoles = ["SEC", "TR", "PER"];
  //   const allowedRoles = ["JC", "COM", "Dr", "SC", "DT", "HJC", "SA", "HJC", "DY", "HOS", "HJR"];

  //   if (allowedRoles.includes(userDetail?.Role?.Role_Identifier)) {
  //     navigate('/approved');  // ✅ Navigate for allowed roles
  //   }
  // };

  const option_Status = [
    { value: 'all', label: 'All Application' },
    { value: 'approve', label: 'Approved Application' },
    { value: 'raiseQuery', label: 'Raised Query Application' },
    { value: 'pending', label: 'Pending Application' },
    { value: 'resubmission', label: 'Resubmission Application' }
  ];

  /// To Get the District Api....
  const getTDistrict = async () => {
    // setIsLoad(true);
    try {
      let res: any;
      if (['HOS', 'DY', 'DT', 'SC'].includes(roleIdentifier)) {
        res = await getAllAPMC(token, '', '');
      } else {
        res = await fetchUserAssignedDistrictWithAPMC(token);
      }
      if (res?.success == true) {
       
        setDistrincData(res?.data);
      } else {
        toast.error(res?.message, { position: "top-right" });
      }
    } catch (error) {
  
      toast.error("Something went wrong while fetching District/Tehsil.", {
        position: "top-right",
      });
    } finally {
      // setIsLoad(false); // 🔹 Stop loading
    }
  }

 

  const getAPMC = async (districSelect: any) => {
   
    if (districSelect) {
      try {
        // clear previous APMC data when district changes
        setApmcData([]);

        const allApmc: any[] = [];

        if (['HOS', 'DY', 'DT', 'SC'].includes(roleIdentifier)) {
          for (const district of districSelect) {
            const res = await getAllAPMC(token, district, '');

            if (res?.success && Array.isArray(res?.data)) {
              allApmc.push(...res.data); // append response
            }
          }
          // OPTIONAL: remove duplicate APMCs by id
          const uniqueApmc = Array.from(
            new Map(allApmc.map(item => [item.id, item])).values()
          );

          setApmcData(uniqueApmc);
        } else {
          const res = await getAllAPMC(token, districSelect, '');
          if (res?.success) {
            setApmcData(res?.data);
          }
        }

      } catch (error) {
        
        toast.error("Something went wrong while fetching APMC.", {
          position: "top-right",
        });
      }
    }

  };

  const districtOptions = [
    { value: "all", label: "All District" },
    ...(distrincData?.map((item: any) => ({
      value: item?.district_id,
      label: item?.District,
    })) || []),
  ];

  useEffect(() => {
    if (!['HOS', 'DY', 'DT', 'SC'].includes(roleIdentifier) && districtOptions) {
      getAPMC(districtOptions[1]?.value)
    }
  }, [distrincData])

  useEffect(() => {
    if (apmcData && apmcData?.length > 0) {
      const options = apmcData.map((item: any) => ({
        value: item?.id,
        label: item?.apmcName,
      }));
      setApmcOptions(options);
     
    } else {
      setApmcOptions([]); // clear when no data
    }
  }, [apmcData]);

  const handleSearch = (value: string) => {
    setSearchText(value);
    setPagination((prev) => ({
      ...prev,
      current: 1, // reset to first page on search
    }));

    fetchApplicantTableData(1, pagination.pageSize, value, statusSelect?.value, districSelect, apmcSelect);
  };

  const handleChangeForAPMC = (selectedOption: any) => {
    setApmcSelect(selectedOption)
    // fetchApplicantTableData(1, pagination.pageSize, searchText, statusSelect?.value, districSelect, selectedOption);
  };

  const handleChangeForDistric = (selectedOption: any) => {
  
    setDistricSelect(selectedOption)
    setApmcSelect(null)
    const districSelect1 = (selectedOption ?? []).map((item: any) => item.value);
    if (selectedOption) {
      getAPMC(districSelect1)
    }
    // fetchApplicantTableData(1, pagination?.pageSize, searchText, statusSelect?.value, selectedOption, apmcSelect);
  };

  const handleChangeForStatus = (selectedOption: any) => {
    setStatusSelect(selectedOption)
    fetchApplicantTableData(1, pagination.pageSize, searchText, selectedOption?.value, districSelect, apmcSelect);
  };

  useEffect(() => {
    if (districSelect) {
      fetchApplicantTableData(
        1,
        pagination?.pageSize,
        searchText,
        statusSelect?.value,
        districSelect,
        apmcSelect
      );
    }
  }, [districSelect, apmcSelect]);

  const entityMap: Record<string, string> = {
    Ind: "Individual",
    Firm: "Firm",
    Company: "Company",
    CoSciety: "Cooperative Society",
    Fpo: "Farmer Producer Organization (FPO)",
    govEnt: "Government Entity",
    Ngo: "Non-Governmental Organization (NGO)",
    partnerFirm: "Partnership Firm",
    Llp: "Limited Liability Partnership (LLP)",
    Trust: "Trust",
    Jv: "Joint Venture",
  };

  const statusMapping: Record<string, string> = {
    permanentReject: "Permanent reject",
    approvedUnsigned: "Approve Unsigned",
    approve: "Approved",
    reject: "Raised Query",
    pending: "Pending",
    resubmission: "Resubmission",
    draft: "Draft"
  };

  // COUNTS DETAILS API...
  const fetchTraderCounts = async () => {
    try {
      setLoader1(true);
      const resp = await fetchTraderPannelData(token);
      if (resp?.success == true) {
     
        setPanelCountOne(resp?.data?.panelCounts['1'] ?? defaultPanelCount)
        setPanelCountThree(resp?.data?.panelCounts['3'] ?? defaultPanelCount)
      } else {
        toast.error(resp?.message, { position: "top-right" });
      }
    } catch (err) {
      toast.error(err, { position: "top-right" });
    } finally {
      setLoader1(false);
    }
  }

  // TABLE SUMMARY APMC/DISTRICT API...
  const fetchTableData = async () => {
    try {
      setLoader2(true);
      const resp = await fetchPanelTablesData(token);
      if (resp?.success == true) {
     
        setdistrictGroup(resp?.data?.PanelEngineerView_District);
        setLicenseSumm(resp?.data?.licenseSummary);
      } else {
        toast.error(resp?.message, { position: "top-right" });
      }
    } catch (err) {
      toast.error(err, { position: "top-right" });
    } finally {
      setLoader2(false);
    }
  }

  ///Application Table API...
  const fetchApplicantTableData = async (page = 1, limit = 10, searchText: any, status: any, districSelect: any, apmcSelect: any) => {
    try {
      setLoader3(true);
      const resp = await fetchApplicantDataPanel(token, page, limit, searchText, status, districSelect, apmcSelect);
      if (resp?.success == true) {
       
        setAppData(resp?.data);
        setPagination({
          current: resp?.pagination?.page,
          pageSize: resp?.pagination?.limit,
          total: resp?.pagination?.total,
        });
      } else {
        toast.error(resp?.message, { position: "top-right" });
      }
    } catch (err) {
      toast.error(err, { position: "top-right" });
    } finally {
      setLoader3(false);
    }
  }

  const refreshHandler = () => {
    fetchTraderCounts();
    fetchTableData();
    fetchApplicantTableData(1, 10, searchText, statusSelect?.value, districSelect, apmcSelect)
  };

  useEffect(() => {
    refreshHandler();
    getTDistrict();
  }, []);

  const tableDataDistrict = Object.entries(districtGroup).map(
    ([districtName, values], index) => ({
      key: index,
      District_Name: districtName,
      totalCount: values?.total ?? 0,
      pendingCount: values?.pending ?? 0,
      // issuedCount: values?.licenseGranted ?? 0,
      issuedCount: (values?.licenseGranted ?? 0) + (values?.unSignedLicense ?? 0),
      raiseQuery: values?.raiseQuery ?? 0
    })
  );

  const tableApplicationData = appData?.map((data, ind) => ({
    key: ind,
    applicationId: data?.applicationId ?? null,
    Department_Name: data?.Department_Name ?? null,
    District_Name: data?.District_Name ?? null,
    createdAt: data?.createdAt ?? null,
    entityType: data?.isPartner == 'true' ? "Firm" : "Individual",
    applicantName: data?.applicantName ?? null,
    licenseType: data?.licenseType ?? null,
    status: data?.status ?? null,
    licenseNo: data?.licenseNo ?? null
  })
  )
 
  ////////////////////////////////////////////
  //GET THE MONTH FROM SUMMARY...
  const months = Object.keys(licenseSumm);

  const licenseOne = months.map(
    (m) => licenseSumm[m]?.["1"] ?? 0
  );

  const licenseThree = months.map(
    (m) => licenseSumm[m]?.["3"] ?? 0
  );

  //left chart...
  const revenue_income: ApexOptions = {
    series: [
      // {
      //   name: "1 Year License",
      //   data: licenseOne
      // },
      {
        name: "3 Year License",
        data: licenseThree
      }
    ],
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "70%",
        borderRadius: 0
      }
    },
    colors: ["#3B82F6"],
    dataLabels: {
      enabled: true,
    },
    xaxis: {
      categories: months,
      title: { text: "Months" }
    },
    yaxis: {
      title: { text: "License Count" }
    },
    legend: {
      position: "top"
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val} Licenses`
      }
    }
  };
  //////////////////////////////////////////////////////////////

  const summaryDistrictColumn = [
    {
      title: language?.district,
      dataIndex: "District_Name",
      key: "District_Name",
      width: 160,
      // render: (District_Name: string | null) => District_Name || "N/A",
      render: (District_Name: string | null) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
          {District_Name}
        </div>
      ),
    },
    {
      title: language?.app_recev,
      dataIndex: "totalCount",
      key: "totalCount",
      width: 160,
      render: (totalCount: number) => totalCount ?? 0,
    },
    {
      title: language?.app_pen,
      dataIndex: "pendingCount",
      key: "pendingCount",
      width: 160,
      render: (pendingCount: number) => pendingCount ?? 0,
    },
    {
      title: language?.lic_iss,
      dataIndex: "issuedCount",
      key: "issuedCount",
      width: 120,
      render: (issuedCount: number) => issuedCount ?? 0,
    },
    {
      title: language?.rejected,
      dataIndex: "raiseQuery",
      key: "raiseQuery",
      width: 120,
      render: (raiseQuery: number) => raiseQuery ?? 0, // Use `??` to handle undefined values
    },
  ]

  const applicationData = [
    {
      title: language.application_id,
      dataIndex: "applicationId",
      key: "applicationId",
      width: 180,
    },
    {
      title: language.district,
      dataIndex: "District_Name",
      key: "District_Name",
      width: 160,
      render: (District_Name: string | null) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
          {District_Name}
        </div>
      ),
    },
    // {
    //   title: language.apmc,
    //   dataIndex: "Department_Name",
    //   key: "Department_Name",
    // },
    {
      // title: language.date_app,
      title: "Applied Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 160,
      sorter: (a: any, b: any) =>
        new Date(a.createdAt || 0).getTime() - new Date(b.createdAt || 0).getTime(),
      defaultSortOrder: "descend" as const,
      // render: (date: string | null) => (date ? new Date(date).toLocaleDateString() : "N/A"),
      render: (date: string | null) => {
        if (!date) return "N/A";
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      },
    },
    {
      title: language?.applicant_type,
      dataIndex: "entityType",
      key: "entityType",
      width: 160,
      // render: (entityType: string | null) => (
      //   entityType
      // ),
      render: (entityType: string | null) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
          {entityType}
        </div>
      ),
    },
    {
      title: "Applicant Name",
      dataIndex: "applicantName",
      key: "applicantName",
      width: 160,
      render: (applicantName: string | null) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
          {applicantName}
        </div>
      ),
    },
    {
      title: language.license_type,
      dataIndex: "licenseType",
      key: "licenseType",
      width: 160,
      render: (type: string | null) => (type === "1" ? "1 Year" : type === "3" ? "3 Years" : "N/A"),
    },
    {
      title: language.status,
      dataIndex: "status",
      key: "status",
      width: 160,
      render: (status: string | null) => (status ? statusMapping[status] : "N/A"),

    },
    {
      title: language.lic_iss,
      dataIndex: "licenseNo",
      key: "licenseNo",
      width: 140,
      render: (licenseNo: string | null) => (licenseNo ? licenseNo : "N/A"),
    },

  ]

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h1 className="mb-1"> {userDetail.Role.Role_Name} {language.dashboard}</h1>
            </div>
            <div>
              <button type="button" className="btn btn-outline-primary"
                onClick={refreshHandler}
                disabled={loader1 && loader2 && loader3}
              >
                {loader1 && loader2 && loader3 ?
                  <>
                    <i className="ti ti-loader ti-spin me-2" />
                    Refreshing...
                  </> :
                  <>
                    <i className="ti ti-refresh me-2" />
                    Refresh
                  </>
                }
              </button>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">

            {/* App Receive====== */}
            <div className="col-xl-6  col-md-6">
              <div className="card position-relative " >
                <div className="card-body">
                  <div className="border shadow-sm">
                    <div className="d-flex align-items-center mb-3 border-bottom">
                      {/* <div className="avatar avatar-md br-10 icon-rotate bg-primary flex-shrink-0">
                      <span className="d-flex align-items-center">
                        <i className="ti ti-file-description text-white fs-16" />
                      </span>
                    </div> */}
                      <div className="d-flex flex-row p-2">
                        <p className="fw-bold text-truncate me-2 mb-1"
                          style={{
                            fontSize: "15px",
                            fontWeight: "bold",
                            // fontStyle: "italic",
                            letterSpacing: "0.5px",
                            lineHeight: "1.5",
                            color: "#585759",
                            // textTransform: "uppercase",
                          }}
                        >
                          {language.app_recev} :
                        </p>
                        <h5
                          style={{
                            // cursor: 'pointer',
                            color: 'orange'
                          }}
                        //  onClick={scrollToTable}
                        >
                          {
                            // panelCountOne?.total + 
                            panelCountThree?.total}
                        </h5>
                      </div>
                    </div>
                    <div className="ms-1 d-flex flex-column align-items-center mb-3">
                      <div className="d-flex justify-content-between w-100">
                        {/* <p className="fw-medium mb-1 text-center w-50">{language.y1}</p> */}
                        <p className="fw-medium mb-1 text-center w-100">{language.y3}</p>
                      </div>
                      <div className="d-flex justify-content-between w-100">
                        {/* <h5 className="fw-bold text-center w-50">
                          {panelCountOne?.total}
                        </h5> */}
                        <h5 className="fw-bold text-center w-100">
                          {panelCountThree?.total}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <span className="position-absolute top-0 end-0">
                    <ImageWithBasePath src="assets/img/bg/card-bg-04.png" alt="Img" />
                  </span>
                </div>
              </div>
            </div>

            {/* App Issue=== */}
            <div className="col-xl-6  col-md-6">
              <div className="card position-relative " >
                <div className="card-body">
                  <div className="border shadow-sm">
                    <div className="d-flex align-items-center mb-3 border-bottom">
                      {/* <div className="avatar avatar-md br-10 icon-rotate bg-primary flex-shrink-0">
                      <span className="d-flex align-items-center">
                        <i className="ti ti-file-description text-white fs-16" />
                      </span>
                    </div> */}
                      <div className="d-flex flex-row p-2">
                        <p className="fw-bold text-truncate me-2 mb-1"
                          style={{
                            fontSize: "15px",
                            fontWeight: "bold",
                            // fontStyle: "italic",
                            letterSpacing: "0.5px",
                            lineHeight: "1.5",
                            color: "#585759",
                            // textTransform: "uppercase",
                          }}
                        >
                          {language.lic_iss} :
                        </p>
                        <h5
                          style={{
                            // cursor: 'pointer',
                            color: 'orange'
                          }}
                        //  onClick={scrollToTable}
                        >
                          {
                            // panelCountOne?.approved +
                            panelCountThree?.approved}
                        </h5>
                      </div>
                    </div>
                    <div className="ms-1 d-flex flex-column align-items-center mb-3">
                      <div className="d-flex justify-content-between w-100">
                        {/* <p className="fw-medium mb-1 text-center w-50">{language.y1}</p> */}
                        <p className="fw-medium mb-1 text-center w-100">{language.y3}</p>
                      </div>
                      <div className="d-flex justify-content-between w-100">
                        {/* <h5 className="fw-bold text-center w-50">
                          {panelCountOne?.approved}
                        </h5> */}
                        <h5 className="fw-bold text-center w-100">
                          {panelCountThree?.approved}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <span className="position-absolute top-0 end-0">
                    <ImageWithBasePath src="assets/img/bg/card-bg-04.png" alt="Img" />
                  </span>
                </div>
              </div>
            </div>

            {/* Reg. Eng/ Total User=== */}
            {/* {["SC", "DT", "HJC", "SA", "HJC", "DY", "HOS", "HJR"].includes(userDetail?.Role?.Role_Identifier) && (
              <div className="col-xl-4 col-md-6">
                <div className="card position-relative"
                  style={{
                    height: "162px",
                  }}>
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-3">
                      <div className="avatar avatar-md br-10 icon-rotate bg-purple flex-shrink-0">
                        <span className="d-flex align-items-center">
                          <i className="ti ti-activity text-white fs-16" />
                        </span>
                      </div>
                      <div className="ms-3">
                        <p className="fw-medium text-truncate mb-1">
                          {language.reg_eng}
                        </p>
                        <h5>{totaluser}</h5>
                      </div>
                    </div>

                    <span className="position-absolute top-0 end-0">
                      <ImageWithBasePath src="assets/img/bg/card-bg-04.png" alt="Img" />
                    </span>
                  </div>
                </div>
              </div>
            )} */}

            {/* App Pending/Resubmition */}
            <div className="col-xl-6 col-md-6">
              <div className="card position-relative " >
                <div className="card-body d-flex flex-column justify-content-center "
                  style={{
                    height: "171px",
                  }}
                >
                  <div className="d-flex align-items-start ">
                    {/* <div className="avatar avatar-md br-10 icon-rotate bg-secondary flex-shrink-0">
                      <span className="d-flex align-items-center">
                        <i className="ti ti-chart-pie text-white fs-16" />
                      </span>
                    </div> */}
                    <div className=" d-flex flex-row align-items-stretch w-100 border shadow-sm">

                      {/* LEFT COLUMN */}
                      <div className="col-6 d-flex flex-column h-100 border-end ">
                        <div className="d-flex flex-row mb-2 p-2">
                          <p className="fw-bold text-truncate mb-1 me-2"
                            style={{
                              fontSize: "15px",
                              fontWeight: "bold",
                              // fontStyle: "italic",
                              letterSpacing: "0.5px",
                              lineHeight: "1.5",
                              color: "#585759",
                              // textTransform: "uppercase",
                            }}
                          >
                            {language.app_pen}:
                          </p>
                          <h5
                            className="cursor-pointer"
                            style={
                              ["JC", "COM", "Dr", "SC", "DT", "HJC", "SA", "HJC", "DY", "HOS", "HJR"]
                                .includes(userDetail.Role.Role_Identifier)
                                ? {
                                  // cursor: "pointer",
                                  color: "orange"
                                }
                                : {}
                            }
                          // onClick={handleNavigate}
                          >
                            {
                              // panelCountOne?.pending +
                              panelCountThree?.pending}
                          </h5>
                        </div>

                        {/* Bottom aligned */}
                        <div className="d-flex flex-column justify-content-center align-items-center border-top p-2">
                          <div
                          // className="d-flex justify-content-between w-100"
                          >
                            {/* <p className="fw-medium mb-1 w-50">{language.y1}</p> */}
                            <p className="fw-medium mb-1 w-100">{language.y3}</p>
                          </div>
                          <div
                          // className="d-flex justify-content-center align-items-center w-100"
                          >
                            {/* <h5 className="fw-bold w-50">
                              {panelCountOne?.pending}
                            </h5> */}
                            <h5 className="fw-bold w-100">
                              {panelCountThree?.pending}
                            </h5>
                          </div>
                        </div>
                      </div>

                      {/* RIGHT COLUMN */}
                      <div className="col-6 d-flex flex-column h-100">
                        <div className="d-flex flex-row mb-2 p-2">
                          <p className="fw-bold text-truncate mb-1 me-2"
                            style={{
                              fontSize: "15px",
                              fontWeight: "bold",
                              // fontStyle: "italic",
                              letterSpacing: "0.5px",
                              lineHeight: "1.5",
                              color: "#585759",
                              // textTransform: "uppercase",
                            }}
                          >
                            {/* {language.app_pen}:  */}
                            Application Resubmission :
                          </p>
                          <h5
                            className="cursor-pointer"
                            style={
                              ["JC", "COM", "Dr", "SC", "DT", "HJC", "SA", "HJC", "DY", "HOS", "HJR"]
                                .includes(userDetail.Role.Role_Identifier)
                                ? {
                                  // cursor: "pointer",
                                  color: "orange"
                                }
                                : {}
                            }
                          // onClick={handleNavigate}
                          >
                            {
                              // panelCountOne?.resubmission +
                              panelCountThree?.resubmission}
                          </h5>
                        </div>

                        {/* Bottom aligned */}
                        <div className="d-flex flex-column justify-content-center align-items-center mt-auto border-top p-2">
                          <div
                          // className="d-flex justify-content-between w-100"
                          >
                            {/* <p className="fw-medium mb-1 w-50">{language.y1}</p> */}
                            <p className="fw-medium mb-1 w-100">{language.y3}</p>
                          </div>
                          <div
                          // className="d-flex justify-content-between w-100"
                          >
                            {/* <h5 className="fw-bold w-50">
                              {panelCountOne?.resubmission}
                            </h5> */}
                            <h5 className="fw-bold w-100">
                              {panelCountThree?.resubmission}
                            </h5>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                  <span className="position-absolute top-0 end-0">
                    <ImageWithBasePath src="assets/img/bg/card-bg-04.png" alt="Img" />
                  </span>
                </div>
              </div>
            </div>

            {/* App Rejected/Raise Query */}
            <div className="col-xl-6  col-md-6">
              <div className="card position-relative " >
                <div className="card-body"
                  style={{
                    height: "171px",
                  }}
                >
                  <div className="border shadow-sm">
                    <div className="d-flex align-items-center mb-3 border-bottom">
                      {/* <div className="avatar avatar-md br-10 icon-rotate bg-primary flex-shrink-0">
                      <span className="d-flex align-items-center">
                        <i className="ti ti-file-description text-white fs-16" />
                      </span>
                    </div> */}
                      <div className=" d-flex flex-row p-2">
                        <p className="fw-bold text-truncate me-2 mb-1"
                          style={{
                            fontSize: "15px",
                            fontWeight: "bold",
                            // fontStyle: "italic",
                            // textDecoration: "underline",
                            letterSpacing: "0.5px",
                            lineHeight: "1.5",
                            color: "#585759",
                            // textTransform: "uppercase",
                          }}
                        >
                          {language.rejected} :
                        </p>
                        <h5 style={{
                          // cursor: 'pointer',
                          color: 'orange'
                        }}
                        // onClick={scrollToTable}
                        >
                          {
                            // panelCountOne?.raiseQuery +
                            panelCountThree?.raiseQuery}
                        </h5>
                      </div>
                    </div>
                    <div className="ms-1 d-flex flex-column justify-content-center align-items-center mb-3">
                      <div
                      // className="d-flex justify-content-between w-100"
                      >
                        {/* <p className="fw-medium mb-1 text-center w-50">{language.y1}</p> */}
                        <p className="fw-medium mb-1 text-center w-100">{language.y3}</p>
                      </div>
                      <div
                      // className="d-flex justify-content-between w-100"
                      >
                        {/* <h5 className="fw-bold text-center w-50">
                          {panelCountOne?.raiseQuery}
                        </h5> */}
                        <h5 className="fw-bold text-center w-100">
                          {panelCountThree?.raiseQuery}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <span className="position-absolute top-0 end-0">
                    <ImageWithBasePath src="assets/img/bg/card-bg-04.png" alt="Img" />
                  </span>
                </div>
              </div>
            </div>

          </div>

          <div className="row">
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h4>{language.month_app_rec}</h4>
                  </div>
                </div>
                <div className="card-body pb-0">
                  <ReactApexChart
                    id="revenue-income"
                    options={revenue_income}
                    series={revenue_income.series}
                    type="bar"
                    height={230}
                  />
                </div>
              </div>
            </div>
            {["JC", "COM", "Dr", "SC", "DT", "HJC", "SA", "HJC", "DY", "HOS", "HJR"].includes(userDetail?.Role?.Role_Identifier) && (
              <div className="col-xl-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h4>{language.app_summ_district}</h4>
                    <div className="d-flex align-items-center">
                    </div>
                  </div>
                  <div className="card-body p-0 d-flex flex-column">
                    <div className="pt-2 flex-fill" style={{ overflowX: "auto" }}>

                      {/* {(tableDataDistrict && tableDataDistrict?.length > 0 ? */}
                      <Table
                        className="table datanew dataTable no-footer"
                        // rowSelection={Selections ? rowSelection : undefined}
                        columns={summaryDistrictColumn}
                        rowHoverable={false}
                        dataSource={tableDataDistrict ?? []}
                        loading={{ spinning: loader2, tip: "Loading..." }}
                        locale={{
                          emptyText: "No data found"
                        }}
                        pagination={{
                          locale: { items_per_page: "" },
                          nextIcon: <i className="ti ti-chevron-right" />,
                          prevIcon: <i className="ti ti-chevron-left" />,
                          defaultPageSize: 5,
                          showSizeChanger: true,
                          pageSizeOptions: ["5", "10", "20", "30"],
                          showTotal: (total, range) => `Showing ${range[0]} - ${range[1]} of ${total} entries`,
                          onChange: (page, pageSize) => {
                          
                          },
                        }}
                        scroll={{ y: 275 }} // sets max height of table body
                        style={{ width: '100%' }}
                      />
                      {/* : <p className="mb-4" style={{ textAlign: "center" }}>No data found</p>
                      )} */}
                    </div>

                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="row">
            <div className="col-xl-12 d-flex h-100">
              <div className="card flex-fill">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                  <h4>{language.app_det}</h4>
                  <div className="d-flex align-items-center">
                  </div>
                </div>
                <div className="mt-3 card-body p-0">
                  <div className="overflow-x-auto">
                    <div className="row">
                      <div className="col-sm-12 d-flex justify-content-end ">
                        <Select
                          className="mx-3 basic-single"
                          options={option_Status}
                          onChange={handleChangeForStatus}
                          defaultValue={statusSelect}
                          placeholder="Select Status"
                        />
                        {['HOS', 'DY', 'DT', 'SC'].includes(roleIdentifier) &&
                          <>
                            <Select
                              className="mx-3 basic-single"
                              options={districtOptions}
                              onChange={handleChangeForDistric}
                              // defaultValue={selectPending}
                              placeholder="Select District"
                              isMulti
                            />
                          </>
                        }
                        {/* <Select
                          className="mx-3 basic-single"
                          options={apmcOptions}
                          onChange={handleChangeForAPMC}
                          value={apmcSelect || "Select APMC"}
                          // defaultValue={appStatus?.label}
                          placeholder="Select APMC"
                          isMulti
                        /> */}
                        <Input
                          className="me-2"
                          placeholder="Search by Applicant Name"
                          value={searchText}
                          onChange={(e) => handleSearch(e.target.value)}
                          style={{ width: 230 }}
                          allowClear
                        />
                      </div>
                    </div>
                    <div className=" pt-3 flex-fill">
                      {/* {tableApplicationData && tableApplicationData.length > 0 ? */}
                      <Table
                        className="table datanew dataTable no-footer"
                        dataSource={tableApplicationData ?? []}
                        columns={applicationData}
                        loading={{ spinning: loader3, tip: "Loading..." }}
                        locale={{
                          emptyText: "No data found"
                        }}
                        pagination={{
                          locale: { items_per_page: "" },
                          nextIcon: <i className="ti ti-chevron-right" />,
                          prevIcon: <i className="ti ti-chevron-left" />,
                          defaultPageSize: 10,
                          current: pagination?.current,
                          pageSize: pagination?.pageSize,
                          total: pagination?.total ?? 0,
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "100", "1000"],
                          showTotal: (total, range) => `Showing ${range[0]} - ${range[1]} of ${total} entries`,
                          onChange: (page, pageSize) => {
                            fetchApplicantTableData(page, pageSize, searchText, statusSelect?.value, districSelect, apmcSelect);
                          },
                        }}
                        scroll={{ y: 550 }}
                        style={{ width: '100%' }}
                      />
                      {/* : <p className="mb-4" style={{ textAlign: "center" }}>No data found</p>
                      } */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
      {/* /Page Wrapper */}
    </>

  );
};

export default PannelEnginnerDashboard;
